/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useFocusTrap } from '@mantine/hooks';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Center,
  Button,
  Title,
  Space,
  Paper,
  Group,
  Text,
  Stack,
  Image,
  Input,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';
import backButton from '../../image/backArrow.png';
import ParkingSlot from '../../image/parking-slot.svg';
import PrimaryButton from '../../components/GroupButton';
import { sendRequest } from '../../services/services';

const Home = () => {
  const navigate = useNavigate();
  const focusTrapRef = useFocusTrap();
  const { t, i18n } = useTranslation();

  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const passIdData = searchParams.get('passId');
  const passTicketId = searchParams.get('passTicketId');

  const [searchText, setSearchText] = useState('');
  const [filteredSites, setFilteredSites] = useState([]);
  const [ticketData, setTicketData] = useState();

  useEffect(() => {
    sendRequest(`parking/reservations-by-pass-id/${passTicketId || passIdData}`, 'get').then(
      (res) => {
        setTicketData(res?.data || []);
      },
    );
  }, [passIdData, passTicketId]);

  const handleSearch = (e) => {
    const text = e.target.value;
    setSearchText(text);
    setFilteredSites(
      ticketData.filter((site) => site.name.toLowerCase().includes(text.toLowerCase())),
    );
  };
  const [mounted, setMounted] = useState(false);
  const [location, setLocation] = useState('');

  useEffect(() => {
    setMounted(true);
    setLocation(`${window.location.protocol}//${window.location.host}/`);
  }, []);

  return (
    <Box>
      <Group>
        <Button
          onClick={() => navigate(-1)}
          color="blue"
          radius="md"
          size="xl"
          leftIcon={<Image src={backButton} width={35} height={20} />}
          px="xl"
        />
        <Space w="xl" />
        <Space w="xl" />
        <Space w="xl" />
        <Space w="xl" />
        <Space w="xl" />
        <Space w="xl" />
        <Center>
          <Title style={{ color: '#F9D923' }} order={1}>
            {t('find.my.car.title.text')}
          </Title>
        </Center>
      </Group>

      <Stack>
        {!passIdData && !passTicketId ? (
          <Input
            placeholder="Ticket Number"
            width="100%"
            // onChange={searchTicket}
            value={passIdData}
            ref={focusTrapRef}
            px="xl"
          />
        ) : null}
        <Group position="apart" px="xl" style={{ marginBottom: 5, marginTop: 5, marginLeft: 20 }}>
          <Stack>
            {ticketData?.result?.id ? (
              <Paper
                shadow="lg"
                radius="lg"
                p="sm"
                mt="lg"
                sx={{
                  backgroundColor: '#01AA84',
                  opacity: '0.9',
                  color: 'white',
                }}
              >
                <Group spacing="xl">
                  <Stack>
                    <Center>
                      <Title order={3}> {t('find.my.car.parked.at.text')}</Title>
                    </Center>
                    {/* <Title order={3}>{ticketData?.result?.vehicles?.number_plate}</Title>
                    <Title order={4}>{ticketData?.site_details?.name}</Title>
                    <Title order={4}>{ticketData?.site_details?.address}</Title>
                    <Title order={4}>{ticketData?.result?.site_parking_slots?.name}</Title>
                    <Title order={4}>
                      {ticketData?.result?.site_parking_slots?.site_parking_slot_types?.name}
                    </Title> */}
                    <Group>
                      <Text>{t('find.my.car.floor.text')}</Text>
                      <Text>3rd</Text>
                    </Group>
                    <Group>
                      <Text>{t('find.my.car.slot.text')}</Text>
                      <Text>25</Text>
                    </Group>
                    <Group>
                      <Text>{t('find.my.car.gate.text')}</Text>
                      <Text>2A</Text>
                    </Group>
                    <Group>
                      <Text>{t('find.my.car.color.text')}</Text>
                      <Text>Yellow</Text>
                    </Group>
                  </Stack>
                </Group>
              </Paper>
            ) : null}
          </Stack>
          {ticketData?.site_details?.id ? (
            <Stack p="xl">
              <Paper shadow="md" p="xl" sx={{ width: '80%' }}>
                <Stack>
                  <Image src={ParkingSlot} width="100%" />
                </Stack>
              </Paper>
            </Stack>
          ) : null}
        </Group>
      </Stack>
      <Space h="xl" />
      <Space h="xs" />
      <PrimaryButton />

      {/* <SimpleGrid cols={4} position="apart" px="xl">
        <Button
          color="blue"
          radius="md"
          size="xl"
          style={{
            width: '200px',
            height: '70px',
            backgroundColor: '#4D6D78',
            position: 'fixed',
            left: 100,
            bottom: 55,
          }}

          // onClick={changeLanguageHandler('en')}
        >
          <Title order={1}>عربي</Title>
        </Button> */}
      {/* <select className="custom-select" style={{ width: 200 }} onChange={changeLanguageHandler}>
          <option value="en">English</option> <option value="ar">Arabic</option>
        </select> */}
      {/* <div />
        <div />
        <Button
          onClick={() => navigate('/')}
          color="blue"
          radius="md"
          size="xl"
          style={{
            width: '200px',
            height: '70px',
            backgroundColor: '#4D6D78',
            position: 'fixed',
            right: 100,
            bottom: 55,
          }}
        >
          <Title order={1}>Home</Title>
        </Button>
      </SimpleGrid> */}
    </Box>
  );
};

export default Home;
